module.exports = __webpack_public_path__ + "img/icon-cashless.dcc91dfd.svg";